import { render } from "./GoalAction.vue?vue&type=template&id=44e341c2"
import script from "./GoalAction.vue?vue&type=script&lang=js"
export * from "./GoalAction.vue?vue&type=script&lang=js"
script.render = render

export default script